import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme) => ({
  accordion: {
    backgroundColor: colors.white,
  },
  accordionContainer: {
    marginTop: '26px',
  },
  accordionContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  accordionLink: {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '20px',
    color: colors.blue.l60,
    textDecorationLine: 'none',
    paddingTop: '6px',
  },
  headerAndContent: {
    width: '100%',
    minWidth: '100%',
    minHeight: 'calc(100vh - 88px)',
    padding: '0',
  },
  sitemapContainer: {
    marginTop: '64px',
    [theme.breakpoints.down('md')]: {
      marginTop: '32px',
    },
  },
}));
